import { Badge, Checkbox } from '@cloudflare/kumo';
import { useEffect, useState } from 'react';
import { useAuthenticatedFetch } from '../../hooks/useAuthenticatedFetch';

interface Tool { name: string; label: string; description: string; writes: boolean; kind?: 'native' | 'http' }

/** Bloco IA: ferramentas da plataforma que a IA pode usar na conversa */
export function AiToolsPicker({ value, onChange }: { value: string[]; onChange: (v: string[]) => void }) {
  const fetchApi = useAuthenticatedFetch();
  const [tools, setTools] = useState<Tool[]>([]);
  useEffect(() => {
    fetchApi('/api/ai/tools').then((r) => (r.ok ? r.json() : { tools: [] })).then((d) => setTools(d.tools || [])).catch(() => setTools([]));
  }, [fetchApi]);
  if (!tools.length) return null;
  const toggle = (name: string, on: boolean) => onChange(on ? [...new Set([...value, name])] : value.filter((n) => n !== name));
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">Ferramentas</label>
      <p className="text-xs text-gray-500 mb-2">O que a IA pode fazer sozinha durante a conversa. Tudo fica registrado.</p>
      <div className="space-y-2">
        {tools.map((t) => (
          <div key={t.name} className="flex items-start gap-2">
            <div>
              <Checkbox onCheckedChange={(checked: boolean) => toggle(t.name, checked)} checked={value.includes(t.name)} labelTooltip={t.description} label={<>
                <span className="text-sm">
                  {t.label}{' '}
                  {t.kind === 'http' && <Badge variant="blue" className="ml-1">API</Badge>}{' '}
                  {t.writes && <Badge variant="orange" className="ml-1">grava dados</Badge>}
                </span>
              </>} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
